// Resolve the CloudFront base at runtime first: the server injects
// `window.__CDN_BASE__` into index.html with this environment's CloudFront
// domain (see lib/clientHtml.js). This lets a single promoted build serve the
// correct CDN on dev/staging/prod. Fall back to the build-time VITE_CDN_BASE
// (used for local dev), then to relative /media paths.
const RUNTIME_CDN_BASE
  = (typeof window !== 'undefined' && window.__CDN_BASE__) || ''
const CDN_BASE = (RUNTIME_CDN_BASE || import.meta.env.VITE_CDN_BASE || '').replace(/\/$/, '')

/**
 * @param {string|null|undefined} imageId
 * @param {'original'|'regular'|'small'|'thumb'} version
 * @returns {string} CloudFront URL for the image, or '' if imageId is falsy.
 */
export function mediaUrl(imageId, version = 'small') {
  if (!imageId) return ''
  const path = `/media/${imageId}/${version}`
  
  return CDN_BASE ? `${CDN_BASE}${path}` : path
}
